import React, { useState } from "react";
import type { CSSProperties } from "react";
import { FaInstagram as FaInstagramRaw, FaWhatsapp as FaWhatsappRaw, FaYoutube as FaYoutubeRaw, FaFacebookF as FaFacebookRaw } from "react-icons/fa";
import SocialQrModal from "./SocialQrModal";
import { FONT_DISPLAY, FONT_MONO } from "theme/fonts";
import { useContactModalText } from "./Contactmodal.text";
// react-icons v5's IconType returns ReactNode, which React 19's stricter JSX
// component typing rejects — cast once here rather than at every call site.
const FaInstagram = FaInstagramRaw as unknown as React.FC<{ size?: number }>;
const FaWhatsapp  = FaWhatsappRaw  as unknown as React.FC<{ size?: number }>;
const FaYoutube   = FaYoutubeRaw   as unknown as React.FC<{ size?: number }>;
const FaFacebook  = FaFacebookRaw  as unknown as React.FC<{ size?: number }>;

const mono = FONT_MONO;

// TODO: replace with the real Instagram handle and WhatsApp number.
const SOCIAL_LINKS = {
  instagram: "https://instagram.com/yogyism",
  whatsapp:  "https://chat.whatsapp.com/EIASdNv9ujzFKnGFmPfxBp",
  youtube:   "https://www.youtube.com/@Yogyism",
  facebook:  "https://www.facebook.com/profile.php?id=61591601232638",
};

const WEB3FORMS_ACCESS_KEY = "093989f0-a2fb-4eb9-9bd2-f464fe02ff8f";

const COUNTRY_CODES: { code: string; dial: string }[] = [
  { code: "AF", dial: "+93"   }, { code: "AX", dial: "+358"  }, { code: "AL", dial: "+355"  },
  { code: "DZ", dial: "+213"  }, { code: "AS", dial: "+1684" }, { code: "AD", dial: "+376"  },
  { code: "AO", dial: "+244"  }, { code: "AI", dial: "+1"    }, { code: "AQ", dial: "+672"  },
  { code: "AG", dial: "+1"    }, { code: "AR", dial: "+54"   }, { code: "AM", dial: "+374"  },
  { code: "AW", dial: "+297"  }, { code: "AU", dial: "+61"   }, { code: "AT", dial: "+43"   },
  { code: "AZ", dial: "+994"  }, { code: "BS", dial: "+1"    }, { code: "BH", dial: "+973"  },
  { code: "BD", dial: "+880"  }, { code: "BB", dial: "+1246" }, { code: "BY", dial: "+375"  },
  { code: "BE", dial: "+32"   }, { code: "BZ", dial: "+501"  }, { code: "BJ", dial: "+229"  },
  { code: "BM", dial: "+1"    }, { code: "BT", dial: "+975"  }, { code: "BO", dial: "+591"  },
  { code: "BQ", dial: "+599"  }, { code: "BA", dial: "+387"  }, { code: "BW", dial: "+267"  },
  { code: "BV", dial: "+47"   }, { code: "BR", dial: "+55"   }, { code: "IO", dial: "+246"  },
  { code: "BN", dial: "+673"  }, { code: "BG", dial: "+359"  }, { code: "BF", dial: "+226"  },
  { code: "BI", dial: "+257"  }, { code: "CV", dial: "+238"  }, { code: "KH", dial: "+855"  },
  { code: "CM", dial: "+237"  }, { code: "CA", dial: "+1"    }, { code: "KY", dial: "+1"    },
  { code: "CF", dial: "+236"  }, { code: "TD", dial: "+235"  }, { code: "CL", dial: "+56"   },
  { code: "CN", dial: "+86"   }, { code: "CX", dial: "+61"   }, { code: "CC", dial: "+61"   },
  { code: "CO", dial: "+57"   }, { code: "KM", dial: "+269"  }, { code: "CG", dial: "+242"  },
  { code: "CD", dial: "+243"  }, { code: "CK", dial: "+682"  }, { code: "CR", dial: "+506"  },
  { code: "CI", dial: "+225"  }, { code: "HR", dial: "+385"  }, { code: "CU", dial: "+53"   },
  { code: "CW", dial: "+599"  }, { code: "CY", dial: "+357"  }, { code: "CZ", dial: "+420"  },
  { code: "DK", dial: "+45"   }, { code: "DJ", dial: "+253"  }, { code: "DM", dial: "+1"    },
  { code: "DO", dial: "+1"    }, { code: "EC", dial: "+593"  }, { code: "EG", dial: "+20"   },
  { code: "SV", dial: "+503"  }, { code: "GQ", dial: "+240"  }, { code: "ER", dial: "+291"  },
  { code: "EE", dial: "+372"  }, { code: "ET", dial: "+251"  }, { code: "FK", dial: "+500"  },
  { code: "FO", dial: "+298"  }, { code: "FJ", dial: "+679"  }, { code: "FI", dial: "+358"  },
  { code: "FR", dial: "+33"   }, { code: "GF", dial: "+594"  }, { code: "PF", dial: "+689"  },
  { code: "TF", dial: "+262"  }, { code: "GA", dial: "+241"  }, { code: "GM", dial: "+220"  },
  { code: "GE", dial: "+995"  }, { code: "DE", dial: "+49"   }, { code: "GH", dial: "+233"  },
  { code: "GI", dial: "+350"  }, { code: "GR", dial: "+30"   }, { code: "GL", dial: "+299"  },
  { code: "GD", dial: "+1"    }, { code: "GP", dial: "+590"  }, { code: "GU", dial: "+1"    },
  { code: "GT", dial: "+502"  }, { code: "GG", dial: "+44"   }, { code: "GN", dial: "+224"  },
  { code: "GW", dial: "+245"  }, { code: "GY", dial: "+592"  }, { code: "HT", dial: "+509"  },
  { code: "HM", dial: "+672"  }, { code: "VA", dial: "+39"   }, { code: "HN", dial: "+504"  },
  { code: "HK", dial: "+852"  }, { code: "HU", dial: "+36"   }, { code: "IS", dial: "+354"  },
  { code: "IN", dial: "+91"   }, { code: "ID", dial: "+62"   }, { code: "IR", dial: "+98"   },
  { code: "IQ", dial: "+964"  }, { code: "IE", dial: "+353"  }, { code: "IM", dial: "+44"   },
  { code: "IL", dial: "+972"  }, { code: "IT", dial: "+39"   }, { code: "JM", dial: "+1876" },
  { code: "JP", dial: "+81"   }, { code: "JE", dial: "+44"   }, { code: "JO", dial: "+962"  },
  { code: "KZ", dial: "+7"    }, { code: "KE", dial: "+254"  }, { code: "KI", dial: "+686"  },
  { code: "KP", dial: "+850"  }, { code: "KR", dial: "+82"   }, { code: "XK", dial: "+383"  },
  { code: "KW", dial: "+965"  }, { code: "KG", dial: "+996"  }, { code: "LA", dial: "+856"  },
  { code: "LV", dial: "+371"  }, { code: "LB", dial: "+961"  }, { code: "LS", dial: "+266"  },
  { code: "LR", dial: "+231"  }, { code: "LY", dial: "+218"  }, { code: "LI", dial: "+423"  },
  { code: "LT", dial: "+370"  }, { code: "LU", dial: "+352"  }, { code: "MO", dial: "+853"  },
  { code: "MK", dial: "+389"  }, { code: "MG", dial: "+261"  }, { code: "MW", dial: "+265"  },
  { code: "MY", dial: "+60"   }, { code: "MV", dial: "+960"  }, { code: "ML", dial: "+223"  },
  { code: "MT", dial: "+356"  }, { code: "MH", dial: "+692"  }, { code: "MQ", dial: "+596"  },
  { code: "MR", dial: "+222"  }, { code: "MU", dial: "+230"  }, { code: "YT", dial: "+262"  },
  { code: "MX", dial: "+52"   }, { code: "FM", dial: "+691"  }, { code: "MD", dial: "+373"  },
  { code: "MC", dial: "+377"  }, { code: "MN", dial: "+976"  }, { code: "ME", dial: "+382"  },
  { code: "MS", dial: "+1"    }, { code: "MA", dial: "+212"  }, { code: "MZ", dial: "+258"  },
  { code: "MM", dial: "+95"   }, { code: "NA", dial: "+264"  }, { code: "NR", dial: "+674"  },
  { code: "NP", dial: "+977"  }, { code: "NL", dial: "+31"   }, { code: "NC", dial: "+687"  },
  { code: "NZ", dial: "+64"   }, { code: "NI", dial: "+505"  }, { code: "NE", dial: "+227"  },
  { code: "NG", dial: "+234"  }, { code: "NU", dial: "+683"  }, { code: "NF", dial: "+672"  },
  { code: "MP", dial: "+1670" }, { code: "NO", dial: "+47"   }, { code: "OM", dial: "+968"  },
  { code: "PK", dial: "+92"   }, { code: "PW", dial: "+680"  }, { code: "PS", dial: "+970"  },
  { code: "PA", dial: "+507"  }, { code: "PG", dial: "+675"  }, { code: "PY", dial: "+595"  },
  { code: "PE", dial: "+51"   }, { code: "PH", dial: "+63"   }, { code: "PN", dial: "+64"   },
  { code: "PL", dial: "+48"   }, { code: "PT", dial: "+351"  }, { code: "PR", dial: "+1"    },
  { code: "QA", dial: "+974"  }, { code: "RE", dial: "+262"  }, { code: "RO", dial: "+40"   },
  { code: "RU", dial: "+7"    }, { code: "RW", dial: "+250"  }, { code: "BL", dial: "+590"  },
  { code: "SH", dial: "+290"  }, { code: "KN", dial: "+1"    }, { code: "LC", dial: "+1"    },
  { code: "MF", dial: "+590"  }, { code: "PM", dial: "+508"  }, { code: "VC", dial: "+1"    },
  { code: "WS", dial: "+685"  }, { code: "SM", dial: "+378"  }, { code: "ST", dial: "+239"  },
  { code: "SA", dial: "+966"  }, { code: "SN", dial: "+221"  }, { code: "RS", dial: "+381"  },
  { code: "SC", dial: "+248"  }, { code: "SL", dial: "+232"  }, { code: "SG", dial: "+65"   },
  { code: "SX", dial: "+1721" }, { code: "SK", dial: "+421"  }, { code: "SI", dial: "+386"  },
  { code: "SB", dial: "+677"  }, { code: "SO", dial: "+252"  }, { code: "ZA", dial: "+27"   },
  { code: "GS", dial: "+500"  }, { code: "SS", dial: "+211"  }, { code: "ES", dial: "+34"   },
  { code: "LK", dial: "+94"   }, { code: "SD", dial: "+249"  }, { code: "SR", dial: "+597"  },
  { code: "SJ", dial: "+47"   }, { code: "SZ", dial: "+268"  }, { code: "SE", dial: "+46"   },
  { code: "CH", dial: "+41"   }, { code: "TW", dial: "+886"  }, { code: "TJ", dial: "+992"  },
  { code: "TZ", dial: "+255"  }, { code: "TH", dial: "+66"   }, { code: "TL", dial: "+670"  },
  { code: "TG", dial: "+228"  }, { code: "TK", dial: "+690"  }, { code: "TO", dial: "+676"  },
  { code: "TT", dial: "+1868" }, { code: "TN", dial: "+216"  }, { code: "TR", dial: "+90"   },
  { code: "TM", dial: "+993"  }, { code: "TC", dial: "+1"    }, { code: "TV", dial: "+688"  },
  { code: "UG", dial: "+256"  }, { code: "UA", dial: "+380"  }, { code: "AE", dial: "+971"  },
  { code: "GB", dial: "+44"   }, { code: "UM", dial: "+1"    }, { code: "US", dial: "+1"    },
  { code: "UY", dial: "+598"  }, { code: "UZ", dial: "+998"  }, { code: "VU", dial: "+678"  },
  { code: "VE", dial: "+58"   }, { code: "VN", dial: "+84"   }, { code: "VG", dial: "+1"    },
  { code: "VI", dial: "+1"    }, { code: "WF", dial: "+681"  }, { code: "EH", dial: "+212"  },
  { code: "YE", dial: "+967"  }, { code: "ZM", dial: "+260"  }, { code: "ZW", dial: "+263"  },
];

// English names: these are what the e-mail to us contains. The labels shown
// in the form come from Contactmodal.text.ts (same order).
const INTEREST_OPTIONS = [
  "Exploration | Online | Free",
  "Guided | Online | Offline",
  "Weekend | Retreat",
  "DIY | KIT",
  "Others",
];

export interface ContactModalProps {
  isOpen: boolean;
  onClose: () => void;
  accent?: string;
  accentRgb?: string;
}

const ContactModal: React.FC<ContactModalProps> = ({
  isOpen,
  onClose,
  accent = "#378add",
  accentRgb = "55,138,221",
}) => {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    countryCode: "+49",
    phone: "",
    message: "",
  });
  const [interests, setInterests] = useState<string[]>([]);
  const [errors, setErrors]       = useState<Record<string, string>>({});
  const [loading, setLoading]         = useState(false);
  const [submitted, setSubmitted]     = useState(false);
  const [showWhatsApp, setShowWhatsApp]   = useState(false);
  const [showInstagram, setShowInstagram] = useState(false);
  const [showYoutube, setShowYoutube]     = useState(false);
  const [showFacebook, setShowFacebook]   = useState(false);
  const t = useContactModalText();

  if (!isOpen) return null;

  const set = (key: string, val: string) => setForm(f => ({ ...f, [key]: val }));

  const toggleInterest = (opt: string) =>
    setInterests(prev =>
      prev.includes(opt) ? prev.filter(o => o !== opt) : [...prev, opt]
    );

  const validate = (): Record<string, string> => {
    const e: Record<string, string> = {};
    if (!form.firstName.trim())  e.firstName = t.errors.required;
    if (!form.lastName.trim())   e.lastName  = t.errors.required;
    if (!form.email.trim())      e.email     = t.errors.required;
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) e.email = t.errors.invalidEmail;
    if (form.phone.trim() && !/^\d{5,15}$/.test(form.phone)) e.phone = t.errors.invalidPhone;
    if (interests.length === 0)  e.interests = t.errors.selectOne;
    if (!form.message.trim())    e.message   = t.errors.required;
    return e;
  };

  const handleSubmit = async () => {
    const e = validate();
    if (Object.keys(e).length) { setErrors(e); return; }

    setLoading(true);
    try {
      const res = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          access_key: WEB3FORMS_ACCESS_KEY,
          subject: `New Dreamfulness Inquiry from ${form.firstName} ${form.lastName}`,
          from_name: "Dreamfulness Contact Form",
          name: `${form.firstName} ${form.lastName}`,
          email: form.email,
          ...(form.phone.trim() ? { phone: `${form.countryCode} ${form.phone}` } : {}),
          "Keen on": interests.join(", "),
          message: form.message,
        }),
      });
      const data = await res.json();
      if (!data.success) {
        throw new Error(data.message || "Submission failed");
      }
      setSubmitted(true);
    } catch (err: any) {
      console.error("Web3Forms send error:", err);
      setErrors({ submit: t.errors.submit });
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setForm({ firstName: "", lastName: "", email: "", countryCode: "+49", phone: "", message: "" });
    setInterests([]); setErrors({}); setSubmitted(false); setLoading(false);
    onClose();
  };

  // ── Styles ────────────────────────────────────────────────────────────────
  const overlay: CSSProperties = {
    position: "fixed", inset: 0, zIndex: 10000, // higher than LoginModal's 9999
    background: "rgba(0,0,0,0.72)", backdropFilter: "blur(5px)",
    display: "flex", alignItems: "center", justifyContent: "center",
    padding: 16,
  };
  const modal: CSSProperties = {
    background: "#0d2235",
    border: `1px solid rgba(${accentRgb},0.28)`,
    borderRadius: 14, width: "100%", maxWidth: 560,
    maxHeight: "92vh", overflowY: "auto",
    boxShadow: "0 24px 60px rgba(0,0,0,0.75)",
    scrollbarWidth: "thin",
    scrollbarColor: `rgba(${accentRgb},0.3) transparent`,
  };
  const modalHeader: CSSProperties = {
    display: "flex", alignItems: "center", justifyContent: "space-between",
    padding: "18px 24px 14px",
    borderBottom: `1px solid rgba(${accentRgb},0.18)`,
    position: "sticky", top: 0, background: "#0d2235", zIndex: 2,
  };
  const lbl = (err?: string): CSSProperties => ({
    display: "block", fontSize: 11,
    color: err ? "#ff9a9a" : "rgba(255,255,255,0.45)",
    letterSpacing: 1, textTransform: "uppercase",
    fontFamily: mono, marginBottom: 5,
  });
  const inp = (err?: string): CSSProperties => ({
    width: "100%", boxSizing: "border-box",
    background: "#071520",
    border: `1px solid ${err ? "rgba(220,90,90,0.55)" : `rgba(${accentRgb},0.28)`}`,
    borderRadius: 6, padding: "9px 12px",
    color: "white", fontSize: 13, fontFamily: mono,
    outline: "none", transition: "border-color 0.2s",
  });
  const errTxt: CSSProperties = { fontSize: 11, color: "#ff9a9a", fontFamily: mono, marginTop: 4 };
  const submitBtn = (disabled: boolean): CSSProperties => ({
    width: "100%",
    background: disabled ? "rgba(55,138,221,0.45)" : accent,
    border: "none", borderRadius: 6, padding: "11px 0",
    color: "white", fontSize: 13, fontFamily: mono,
    letterSpacing: 1, textTransform: "uppercase",
    cursor: disabled ? "not-allowed" : "pointer",
    fontWeight: 600, transition: "background 0.2s",
  });
  const selectStyle: CSSProperties = {
    ...inp(),
    appearance: "none",
    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%23378add' stroke-width='2'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E")`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "right 10px center",
    backgroundSize: "12px",
    paddingRight: 28,
    cursor: "pointer",
  };

  return (
    <div style={overlay} onClick={e => { if (e.target === e.currentTarget) handleClose(); }}>
      <div style={modal}>

        {/* Header */}
        <div style={modalHeader}>
          <div>
            <div style={{ fontFamily: FONT_DISPLAY, fontStyle: "normal", fontWeight: 600, fontSize: 20, color: accent, letterSpacing: 0.5 }}>
              Dreamfulness
            </div>
            <div style={{ fontSize: 11, color: "rgba(255,255,255,0.38)", marginTop: 3, letterSpacing: 1, textTransform: "uppercase", fontFamily: mono }}>
              {t.subtitle}
            </div>
          </div>
          <button
            onClick={handleClose}
            aria-label={t.closeAria}
            style={{
              background: "transparent",
              border: `1px solid rgba(${accentRgb},0.28)`,
              borderRadius: 6, width: 30, height: 30, flexShrink: 0,
              color: "rgba(255,255,255,0.45)", cursor: "pointer",
              fontSize: 16, display: "flex", alignItems: "center", justifyContent: "center",
            }}
          >✕</button>
        </div>

        {/* Body */}
        <div style={{ padding: "20px 24px 24px" }}>
          {submitted ? (
            <div style={{ textAlign: "center", padding: "36px 0" }}>
              <div style={{
                fontFamily: FONT_DISPLAY, fontWeight: 600, width: 56, height: 56, borderRadius: "50%",
                background: `rgba(${accentRgb},0.15)`,
                border: `1px solid rgba(${accentRgb},0.4)`,
                display: "flex", alignItems: "center", justifyContent: "center",
                margin: "0 auto 16px", fontSize: 24, color: accent,
              }}>✓</div>
              <div style={{ fontFamily: FONT_DISPLAY, fontWeight: 600, fontStyle: "normal", fontSize: 18, color: accent, marginBottom: 8 }}>
                {t.sentTitle}
              </div>
              <div style={{ color: "rgba(255,255,255,0.45)", fontSize: 13, fontFamily: mono }}>
                {t.sentBody}
              </div>
              <button onClick={handleClose} style={{ ...submitBtn(false), marginTop: 28, width: "auto", padding: "10px 36px" }}>
                {t.close}
              </button>
            </div>
          ) : (
            <>
              {/* First + Last name */}
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14, marginBottom: 14 }}>
                <div>
                  <label style={lbl(errors.firstName)}>{t.firstName} <span style={{ color: accent }}>*</span></label>
                  <input value={form.firstName} onChange={e => { set("firstName", e.target.value); setErrors(v => ({ ...v, firstName: "" })); }} placeholder={t.firstNamePh} style={inp(errors.firstName)} />
                  {errors.firstName && <div style={errTxt}>{errors.firstName}</div>}
                </div>
                <div>
                  <label style={lbl(errors.lastName)}>{t.lastName} <span style={{ color: accent }}>*</span></label>
                  <input value={form.lastName} onChange={e => { set("lastName", e.target.value); setErrors(v => ({ ...v, lastName: "" })); }} placeholder={t.lastNamePh} style={inp(errors.lastName)} />
                  {errors.lastName && <div style={errTxt}>{errors.lastName}</div>}
                </div>
              </div>

              {/* Email */}
              <div style={{ marginBottom: 14 }}>
                <label style={lbl(errors.email)}>{t.email} <span style={{ color: accent }}>*</span></label>
                <input type="email" value={form.email} onChange={e => { set("email", e.target.value); setErrors(v => ({ ...v, email: "" })); }} placeholder={t.emailPh} style={inp(errors.email)} />
                {errors.email && <div style={errTxt}>{errors.email}</div>}
              </div>

              {/* Country code + Phone */}
              <div style={{ display: "grid", gridTemplateColumns: "160px 1fr", gap: 14, marginBottom: 14 }}>
                <div>
                  <label style={lbl()}>{t.code}</label>
                  <select value={form.countryCode} onChange={e => set("countryCode", e.target.value)} style={selectStyle}>
                    {COUNTRY_CODES.map(c => (
                      <option key={`${c.code}-${c.dial}`} value={c.dial}>{c.code} {c.dial}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label style={lbl(errors.phone)}>{t.phone} <span style={{ color: "rgba(255,255,255,0.3)" }}>{t.optional}</span></label>
                  <input type="tel" value={form.phone} onChange={e => { set("phone", e.target.value.replace(/\D/g, "")); setErrors(v => ({ ...v, phone: "" })); }} placeholder="1234567890" style={inp(errors.phone)} />
                  {errors.phone && <div style={errTxt}>{errors.phone}</div>}
                </div>
              </div>

              {/* Interests */}
              <div style={{ marginBottom: 14 }}>
                <label style={lbl(errors.interests)}>
                  {t.interestsLabel} <span style={{ color: accent }}>*</span>
                </label>
                <div style={{ display: "flex", flexDirection: "column", gap: 9, marginTop: 6 }}>
                  {INTEREST_OPTIONS.map((opt, i) => (
                    <label key={opt} style={{ display: "flex", alignItems: "center", gap: 10, cursor: "pointer", color: "rgba(255,255,255,0.78)", fontSize: 13, fontFamily: mono }}>
                      <input
                        type="checkbox"
                        checked={interests.includes(opt)}
                        onChange={() => { toggleInterest(opt); setErrors(v => ({ ...v, interests: "" })); }}
                        style={{ accentColor: accent, width: 15, height: 15, flexShrink: 0, cursor: "pointer" }}
                      />
                      {t.interestOptions[i] ?? opt}
                    </label>
                  ))}
                </div>
                {errors.interests && <div style={errTxt}>{errors.interests}</div>}
              </div>

              {/* Message */}
              <div style={{ marginBottom: 20 }}>
                <label style={lbl(errors.message)}>{t.message} <span style={{ color: accent }}>*</span></label>
                <textarea
                  rows={4}
                  value={form.message}
                  onChange={e => { set("message", e.target.value); setErrors(v => ({ ...v, message: "" })); }}
                  placeholder={t.messagePh}
                  style={{ ...inp(errors.message), resize: "vertical", fontFamily: mono, lineHeight: "1.6" }}
                />
                {errors.message && <div style={errTxt}>{errors.message}</div>}
              </div>

              {errors.submit && (
                <div style={{ ...errTxt, marginBottom: 12, textAlign: "center", fontSize: 12 }}>
                  {errors.submit}
                </div>
              )}

              <button onClick={handleSubmit} style={submitBtn(loading)} disabled={loading}>
                {loading ? t.sending : t.send}
              </button>
            </>
          )}

          {/* Follow us */}
          <div style={{
            display: "flex", alignItems: "center", justifyContent: "center", gap: 14,
            marginTop: 22, paddingTop: 18, borderTop: `1px solid rgba(${accentRgb},0.18)`,
          }}>
            <span style={{ fontSize: 11, color: "rgba(255,255,255,0.45)", letterSpacing: 1, textTransform: "uppercase", fontFamily: mono }}>
              {t.followUs}
            </span>
            <button
              onClick={() => setShowInstagram(true)}
              aria-label="Instagram"
              style={{
                display: "inline-flex", alignItems: "center", justifyContent: "center",
                width: 30, height: 30, borderRadius: "50%",
                border: `1px solid rgba(${accentRgb},0.35)`, color: "rgba(255,255,255,0.85)",
                background: "transparent", cursor: "pointer",
              }}
            >
              <FaInstagram size={15} />
            </button>
            <button
              onClick={() => setShowWhatsApp(true)}
              aria-label="WhatsApp"
              style={{
                display: "inline-flex", alignItems: "center", justifyContent: "center",
                width: 30, height: 30, borderRadius: "50%",
                border: `1px solid rgba(${accentRgb},0.35)`, color: "rgba(255,255,255,0.85)",
                background: "transparent", cursor: "pointer",
              }}
            >
              <FaWhatsapp size={16} />
            </button>
            <button
              onClick={() => setShowYoutube(true)}
              aria-label="YouTube"
              style={{
                display: "inline-flex", alignItems: "center", justifyContent: "center",
                width: 30, height: 30, borderRadius: "50%",
                border: `1px solid rgba(${accentRgb},0.35)`, color: "rgba(255,255,255,0.85)",
                background: "transparent", cursor: "pointer",
              }}
            >
              <FaYoutube size={16} />
            </button>
            <button
              onClick={() => setShowFacebook(true)}
              aria-label="Facebook"
              style={{
                display: "inline-flex", alignItems: "center", justifyContent: "center",
                width: 30, height: 30, borderRadius: "50%",
                border: `1px solid rgba(${accentRgb},0.35)`, color: "rgba(255,255,255,0.85)",
                background: "transparent", cursor: "pointer",
              }}
            >
              <FaFacebook size={15} />
            </button>
          </div>
        </div>
      </div>

      <SocialQrModal
        isOpen={showWhatsApp}
        onClose={() => setShowWhatsApp(false)}
        network="whatsapp"
        qrSrc="/image/whatsappQr.png"
        link={SOCIAL_LINKS.whatsapp}
        accent={accent}
        accentRgb={accentRgb}
      />

      <SocialQrModal
        isOpen={showInstagram}
        onClose={() => setShowInstagram(false)}
        network="instagram"
        qrSrc="/image/instagramQr.png"
        link={SOCIAL_LINKS.instagram}
        accent={accent}
        accentRgb={accentRgb}
      />

      <SocialQrModal
        isOpen={showYoutube}
        onClose={() => setShowYoutube(false)}
        network="youtube"
        qrSrc="/image/YtQr.png"
        link={SOCIAL_LINKS.youtube}
        accent={accent}
        accentRgb={accentRgb}
      />

      <SocialQrModal
        isOpen={showFacebook}
        onClose={() => setShowFacebook(false)}
        network="facebook"
        qrSrc="/image/FbQr.png"
        link={SOCIAL_LINKS.facebook}
        accent={accent}
        accentRgb={accentRgb}
      />
    </div>
  );
};

export default ContactModal;